import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { alertState } from 'utils/recoil/snackbar';
import {
  formatContentfulComponentProps,
  openInNewTab,
  returnFormatedDate,
} from 'utils/globals';
import { Form } from '../../../UI/Forms/Form/form';
import { Body, Button } from '../../../UI/Elements';
import { AddressCard } from '../AddressCard/addressCard';
import { UserDetailsHeader } from '../Header/userDetailsHeader';
import NoozApi from '../../../../services/NoozApi';

export const TrackOrderForm = ({ form, headerBody, button, ordersData }) => {
  const { errorLabels, inputs, body, submitButton } = form;
  const { label } = formatContentfulComponentProps(ordersData);
  const { orderComponent } = formatContentfulComponentProps(ordersData);
  const {
    EmptyAccountLabel,
    dateLabel,
    numberLabel,
    fulfillment,
    payment,
    viewOrderButton,
  } = formatContentfulComponentProps(orderComponent);
  const { dispatchedLabel, notDispatchedLabel, restockedLabel } =
    formatContentfulComponentProps(fulfillment);
  const {
    authorizedLabel,
    paidLabel,
    partiallyPaidLabel,
    partiallyRefundedLabel,
    pendingLabel,
    refundedLabel,
    voidedLabel,
  } = formatContentfulComponentProps(payment);

  const [alert, setAlert] = useRecoilState(alertState);
  const [isLoading, setIsLoading] = useState(false);
  const [followOrders, setFollowOrders] = useState(null);

  const onSubmit = (data) => {
    setIsLoading(true);
    NoozApi.post('/orders/track', data)
      .then((response) => {
        const orders = response.data.orders.map((order) => ({
          processedAt: order.created_at,
          orderNumber: order.order_number,
          statusUrl: order.order_status_url,
          fulfillmentStatus: order.fulfillment_status,
          financialStatus: order.financial_status,
        }));
        setIsLoading(false);
        setFollowOrders(orders);
      })
      .catch(({ response }) => {
        setIsLoading(false);
        setAlert({
          ...alert,
          show: true,
          type: 'error',
          title: `${errorLabels[0].text} : ${response?.data.error}`,
        });
      });
  };

  const returnFullfillmentLabel = (fulfillmentStatus) => {
    switch (fulfillmentStatus.toLowerCase()) {
      case 'fulfilled':
        return [{ text: dispatchedLabel.text }, { classname: 'dual' }];
      case 'restocked':
        return [{ text: restockedLabel.text }, { classname: 'bluelight' }];
      default:
        return [{ text: notDispatchedLabel.text }, { classname: 'bluelight' }];
    }
  };

  const returnFinancialLabel = (financialStatus) => {
    switch (financialStatus.toLowerCase()) {
      case 'paid':
        return [{ text: paidLabel.text }, { classname: 'dual' }];
      case 'pending':
        return [{ text: pendingLabel.text }, { classname: 'bluelight' }];
      case 'authorized':
        return [{ text: authorizedLabel.text }, { classname: 'bluelight' }];
      case 'partially_paid':
        return [{ text: partiallyPaidLabel.text }, { classname: 'bluelight' }];
      case 'partially_refunded':
        return [
          { text: partiallyRefundedLabel.text },
          { classname: 'bluelight' },
        ];
      case 'refunded':
        return [{ text: refundedLabel.text }, { classname: 'bluelight' }];
      case 'voided':
        return [{ text: voidedLabel.text }, { classname: 'bluelight' }];
      default:
        return [{ text: voidedLabel.text }, { classname: 'bluelight' }];
    }
  };

  const returnOrderStatus = (order, index) => (
    <div className={`${index === 0 ? 'py-5' : 'pb-5'}`}>
      <AddressCard>
        <div className='w-full flex flex-col sm:items-center sm:flex-row sm:justify-between'>
          <div className='pl-flex flex-col text-left items-start'>
            <div className='flex'>
              <Label
                weight='medium'
                text={`${numberLabel.text} :`}
              />
              &nbsp;
              <Label
                weight='light'
                text={`#${order.orderNumber}`}
              />
            </div>
            <div className='flex'>
              <Label
                weight='medium'
                text={`${dateLabel.text} :`}
              />
              &nbsp;
              <Label
                weight='light'
                text={`${returnFormatedDate(order.processedAt)}`}
              />
            </div>
          </div>
          <div className='sm:flex sm:items-center pt-4 sm:pt-0'>
            {order.financialStatus && (
              <div className='pb-2 sm:pb-0 sm:pr-4'>
                <Badge
                  size='base'
                  type='outlined'
                  color={{ classname: 'primary' }}
                  dotColor={returnFinancialLabel(order.financialStatus)[1]}
                  label={returnFinancialLabel(order.financialStatus)[0]}
                />
              </div>
            )}
            {order.fulfillmentStatus && (
              <div className='pb-2 sm:pb-0 sm:pr-4'>
                <Badge
                  size='base'
                  type='outlined'
                  color={{ classname: 'primary' }}
                  dotColor={returnFullfillmentLabel(order.fulfillmentStatus)[1]}
                  label={returnFullfillmentLabel(order.fulfillmentStatus)[0]}
                />
              </div>
            )}
            <div className='py-4'>
              <Button
                type='white'
                size='sm'
                color={{ classname: 'black' }}
                label={{ text: viewOrderButton.label?.text }}
                icon={{ iconKey: 'HiOutlineSearch' }}
                onClick={() => openInNewTab(order.statusUrl)}
              />
            </div>
          </div>
        </div>
      </AddressCard>
    </div>
  );

  return (
    <div className='w-full max-w-2xl py-5'>
      {headerBody && <Body richBody={headerBody.richBody} />}

      {followOrders ? (
        followOrders.length > 0 ? (
          <div>
            <UserDetailsHeader label={label} />
            {followOrders.map((order, index) =>
              returnOrderStatus(order, index)
            )}
            <Button
              type='contained'
              color={{ classname: 'primary' }}
              onClick={() => setFollowOrders(null)}
              label={{ text: button.label?.text }}
            />
          </div>
        ) : (
          <div className='py-5'>
            <div className='py-5'>
              <AddressCard>
                <Label text={EmptyAccountLabel.text} />
              </AddressCard>
            </div>
            <Button
              type='contained'
              color={{ classname: 'primary' }}
              onClick={() => setFollowOrders(null)}
              label={{ text: button.label?.text }}
            />
          </div>
        )
      ) : (
        <div className='sm:flex sm:justify-center'>
          <div className='w-full sm:w-2/3'>
            <Form
              isLoading={isLoading}
              onSubmit={onSubmit}
              inputs={inputs}
              body={body}
              submitButton={submitButton}
            />
          </div>
        </div>
      )}
    </div>
  );
};
